import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./LandingPage";
import AdminScraper from "./AdminScraper";
import AMCDashboard from "./AMCDashboard";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import WillKartPage from "./WillKartPage";
import WillsPage from "./WillsPage";
import "./App.css";
import { useEffect } from "react";
import { initGA, trackPageView } from "./analytics";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Protected Route Component for Admin
const ProtectedAdminRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';
  
  if (!isLoggedIn) {
    return <Navigate to="/login?type=admin" replace />;
  }
  
  return children;
};

// Protected Route Component for AMC
const ProtectedAMCRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isAmcLoggedIn') === 'true';
  
  if (!isLoggedIn) {
    return <Navigate to="/login?type=amc" replace />;
  }
  
  return children;
};

// Component to track page views
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics when app loads
    initGA();
  }, []);

  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <Router>
        <PageViewTracker />
        <Toaster />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/willkart" element={<WillKartPage />} />
          <Route path="/wills" element={<WillsPage />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedAdminRoute>
                <AdminScraper />
              </ProtectedAdminRoute>
            } 
          />
          <Route 
            path="/amc-dashboard" 
            element={<AMCDashboard />} 
          />
        </Routes>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;
